import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import './styles.less';
import { FormTextAreaField } from '../../../../../semantic-ui/components/form-textarea-field';
import { CustomLoader } from '../../../../../components/custom-loader';

export const ChosenCommentFormView = ({ isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<>
			<div className="chosen-comment-form">
				<Grid className="chosen-comment-form__content">
					<Grid.Row className="chosen-comment-form__content-row">
						<Grid.Column width={15} className="chosen-comment-form__content-column">
							Примечание
							<div className="chosen-comment-form__content-column-field">
								<Field
									name="comment"
									type="text"
									component={FormTextAreaField}
									autoComplete="off"
									width="100%"
									height="100%"
									resize="vertical"
									rows={6}
									placeholder="Добавьте примечание при необходимости"
								/>
							</div>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</div>
		</>
	);
};

ChosenCommentFormView.propTypes = {
	isLoading: PropTypes.bool.isRequired,
};
